
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function AdvisorCourse() {
  const curriculum = [
    {
      session: '第1回',
      title: 'アロマの基本と日本の森林の特徴',
      content: [
        'アロマとは何か？',
        '精油(エッセンシャルオイル)とは何か？',
        'アロマの抽出方法について',
        'なぜ植物はアロマを出すのか？',
        '日本の森林生態系の特徴',
        '地球規模で見た「日本の森から生まれたアロマ」',
        'アロマウォーター(芳香蒸留水)とは何か？',
        '日本産アロマウォーター（芳香蒸留水）の種類と特徴',
        'アロマクラフト実習：ルームスプレー/ボディスプレー/化粧水のいずれかを選択'
      ],
      duration: '2時間'
    },
    {
      session: '第2回',
      title: '日本産の精油・植物油',
      content: [
        '日本人と日本産精油の相性',
        '日本産精油の種類と特徴',
        'ライスキャリアオイルについて',
        '気分を変える芳香浴について',
        '日本の入浴文化こそ、アロマセラピーの原点',
        'ヘッドスパに通ずるシャンプー',
        'アロマクラフト実習：バスオイル'
      ],
      duration: '2時間'
    },
    {
      session: '第3回',
      title: '精油の安全性とトリートメント',
      content: [
        '精油の安全性と信頼性について',
        '簡単なトリートメントについて',
        '「心地良い眠り」と「体内時計調整」のために',
        '「肩こり」「腰痛」「スポーツアロマ」について',
        'yuica精油の使い方のおさらい',
        'アドバイザーから次のステップに向けて',
        'アロマクラフト実習：トリートメントオイル'
      ],
      duration: '2時間'
    }
  ];

  const benefits = [
    {
      icon: 'ri-award-line',
      title: 'yuica公式認定資格',
      description: '和精油の普及を推進しているyuicaの公式認定資格を取得できます。'
    },
    {
      icon: 'ri-book-open-line',
      title: '体系的な学習',
      description: '和精油について基礎から応用まで体系的に学べるカリキュラムです。'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'マンツーマン・オーダーメイド指導',
      description: '１対１の個人指導で、理解度に合わせてきめ細やかにサポートします。'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '柔軟なスケジュール',
      description: '早朝・深夜・土日祝日など、ご都合に合わせて受講日程を調整できます。'
    },
    {
      icon: 'ri-flask-line',
      title: '実習（クラフト）体験',
      description: '理論だけでなく、実際に精油を使った実習で実践的なスキルを身につけます。'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'アフターサポート',
      description: '資格取得後も継続的にサポートし、活動をバックアップします。'
    }
  ];

  const faq = [
    {
      question: '初心者でも受講できますか？',
      answer: 'はい、アロマセラピーが初めての方でも安心してご受講いただけます。基礎から丁寧に指導いたします。'
    },
    {
      question: '受講期間はどのくらいですか？',
      answer: '計6時間の講座について、受講者様のご都合に合わせて回数や期間を調整可能です。'
    },
    {
      question: '資格取得後はどのような活動ができますか？',
      answer: 'yuica認定アドバイザーとして、身の回りの方へ和精油の魅力や使い方を伝えていくことができるようになります。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-green-50"
      >
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">yuica認定 日本産精油<br />アドバイザー資格講座</h1>
          <p className="text-xl mb-6 max-w-3xl mx-auto">
            和精油の専門知識を体系的に学び、認定資格を取得して<br />
            多くの方に和精油の魅力を伝える活動を始めませんか
          </p>
        </div>
      </section>

      {/* Course Overview */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">講座概要</h2>
              <p className="text-gray-600 mb-6">
                yuica認定日本産精油アドバイザー資格講座は、日本産精油の専門知識を体系的に学べる公式認定プログラムです。yuicaの認定カリキュラムに基づき、和精油の基礎から実践的な活用方法まで幅広く習得できます。
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">受講時間</h4>
                    <p className="text-gray-600">計6時間（２時間×全３回）※受講生様のご都合に合わせ、１回の時間と回数は調整可能です</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-money-yen-circle-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">受講料</h4>
                    <p className="text-gray-600">
                      受講料：22,000円（税込）※実習費含む<br />
                      教材費・試験受験料・認定料：30,800円（税込）<br />
                      ※入会金や年会費はありません
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-calendar-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">開講日時</h4>
                    <p className="text-gray-600">個別相談（マンツーマンのため、早朝・深夜など柔軟に調整可能）</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/eefd34b87b1476aad4af92128496bc04.jpeg"
                alt="講座教材"
                className="rounded-lg shadow-lg w-full max-w-md h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Curriculum */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">カリキュラム</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              全3回の講座で、和精油について基礎から応用まで体系的に学習します。
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            {curriculum.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm p-6 mb-4 hover:shadow-md transition-shadow duration-200">
                <div className="flex flex-col md:flex-row md:items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="bg-green-100 text-green-600 font-semibold px-3 py-1 rounded-full text-sm">
                      {item.session}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                      <h3 className="font-semibold text-gray-900 text-lg">{item.title}</h3>
                      <span className="text-gray-500 text-sm">{item.duration}</span>
                    </div>
                    <ul className="text-gray-600 space-y-2">
                      {item.content.map((point, pointIndex) => (
                        <li key={pointIndex} className="flex items-start">
                          <span className="text-green-600 mr-2 mt-1">•</span>
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">受講のメリット</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-green-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">よくあるご質問</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto"></div>
          </div>
          
          <div className="max-w-3xl mx-auto">
            {faq.map((item, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm p-6 mb-4">
                <h3 className="font-semibold text-gray-900 mb-3 flex items-start">
                  <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded mr-3 flex-shrink-0">Q</span>
                  {item.question}
                  </h3>
                <p className="text-gray-600 ml-8">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">お申し込み・お問い合わせ</h2>
          <Button
            size="lg"
            onClick={() => window.REACT_APP_NAVIGATE('/contact')}
            className="bg-green-600 hover:bg-green-7 text-white px-8 py-3"
          >
            お申し込み・お問い合わせ
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
